import styled from '@emotion/styled'

import { Text } from '@cash-design-system/react'
import { CurrencyCode } from '@cash-web/protos/squareup/common/currency_codes.pb'
import { FormBlockerElementMoneyElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { formatMoney } from '@cash-web/shared-feature-common'

const MoneyElementContainer = styled.div`
  text-align: center;
`

export const MoneyElement = ({ amount }: FormBlockerElementMoneyElement) => {
  const { amount: value, currency_code = CurrencyCode.USD } = amount ?? {}

  const displayText = formatMoney({ amount: value, currency_code: currency_code })

  return (
    <MoneyElementContainer>
      <Text typography="numeralLarge" color="textStandard">
        {displayText}
      </Text>
    </MoneyElementContainer>
  )
}
